/**
 * * API KONTROLÜ:
 *    todo: 1. tüm api fonksiyonlarını tekbir fetch fonksiyonu altında topla
 *    todo:    2. jwt tokeni bu class içerisinde çağır ve hiçbir componentde jwt token ile uğraşma
 *    todo:    3. gelen hataları api classında kontrol et(tokenin süresi dolma gibi durumlar).
 *    todo:    4. eski api kullanan tüm fonsiyonları yeni (burası uğraştırır.)
 */
import {handleResponse, handleError, handleResponseBulkUpdate} from "./apiUtils";

const token = window.localStorage.getItem("accessToken");

function getToken() {
    return window.localStorage.getItem("accessToken");
}

export async function SaveOrEdit(model, method, id) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/generic/instances/" +
        id,
        {
            method: method, // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GenericInstance(model, method) {
    return await fetch(
        "https://" + process.env.REACT_APP_BASE_URL + "/omnimap/generic/instances/",
        {
            method: method, // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function DeleteContext(element) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/generic/context/" +
        element,
        {
            method: "DELETE", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function Delete(element) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/generic/instances/" +
        element,
        {
            method: "DELETE", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function DeleteRelation(element) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/generic/context/" +
        element,
        {
            method: "DELETE", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function FillTable(model, page_number, token) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/search/?page-size=100&page-number=" +
        page_number +
        "&includes=PROPERTIES,MONITORING,CONTENT",
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function FillFilterColumns(model, data_id) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/search/definitions/content/keys/" +
        data_id +
        "/values?q=",
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function SearchFilterColumns(model, key, search_id) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/search/definitions/content/keys/" +
        search_id +
        "/values?q=" +
        key,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetTreeStructure(model) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/search/?page-size=30&page-number=1&includes=PROPERTIES,MONITORING,CONTENT,CONTEXT",
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function AddFolder(model) {
    return await fetch(
        "https://" + process.env.REACT_APP_BASE_URL + "/omnimap/generic/instances/",
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function DeleteFolder(model, folder_id) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/generic/instances/" +
        folder_id,
        {
            method: "DELETE", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetActionsOfRow(row_ids) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/instances/flow?instance_identification=" +
        row_ids,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function InstanceFlowActivityInputData(row_ids, model, flowInstance) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        `/omnimap/instances/flow/${flowInstance}/activity/inputdata?instance_identification=` +
        row_ids,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetActionsOfRowSingle(row_ids) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/instances/" +
        row_ids +
        "/actions?layout=list",
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function AddParentFolder(model, child_id) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/instances/flow/708371ee-e3f6-4de7-87f8-dfe94b86f9b1/activity/inputdata?instance_identification=" +
        child_id,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetColumnProperties(pageNumber) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/definitions/instance-definitions?permissions=post&page-number=1&page-number=2&page-number=3&page-size=40`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetEntityList(model, pageNr, pageSize) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/search/?page-size=" +
        pageSize +
        "&page-number=" +
        pageNr +
        "&includes=PROPERTIES,MONITORING,CONTENT",
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function OmnimapPost(model, page_number, page_size) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/search/?page-size=${page_size}&page-number=${page_number}&includes=PROPERTIES,MONITORING,CONTENT`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetRelation(identification, page_number, page_size) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/instances/v2/${identification}/context?page-size=${page_size}&page-number=${page_number}`,
        {
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetAllUsers(
    page_number,
    page_size,
    filter,
    ownOrganisation,
    mandateOrganisation,
    role
) {
    return await fetch(
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/security/users?page-number=" +
        page_number +
        "&page-size=" +
        page_size +
        "&only-active=false&" +
        "filter=" +
        filter +
        "&own-organisation=" +
        ownOrganisation +
        "&mandate-organisation=" +
        mandateOrganisation +
        "&role=" +
        role,
        {
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetAllBySearch(model, page_size=30, page_number=1) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/search/?page-size=${page_size}&page-number=${page_number}&includes=PROPERTIES,MONITORING,CONTENT,CONTEXT`,
        {
            method: "Post", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetRowOfDetail(row_id) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/instances/${row_id}?include=content,status,audit_info,properties,definition`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetContentDetailOfRow(row_id) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/instances/${row_id}?include=content`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetRowOfActionDetailStart(row_id, stage_id) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/instances/${row_id}/flow/stages/${stage_id}`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}
export async function StartActivityFlow(activity_id, instance_ids){
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/instances/flow/${activity_id}/start?instance_identification=${instance_ids}`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}
export async function InputDataActivityFlow(activity_id, instance_ids, model){
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/instances/flow/${activity_id}/activity/inputdata?instance_identification=${instance_ids}`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetRowOfActionDetailPost(row_id) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/activities/${row_id}/inputdata`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function InputdataPost(model, row_id) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/activities/${row_id}/inputdata`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function ValidatePost(row_id) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/activities/${row_id}/validate`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetActivityDefinition(rowId, activiteId) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/instances/${rowId}/flow/activity-definitions/${activiteId}`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetUsers(pageNumber, pageSize, filterKey) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/security/users?page-number=${pageNumber}
    &page-size=${pageSize}&filter=${filterKey}`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetUserByRole(pageNumber, pageSize, role) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/security/users?role=${role}&page-number=${pageNumber}&page-size=${pageSize}&only-active=false`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetDefinationStatus(model) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/search/definitions/statuses`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function StartActionActivity(model, rowId, startId) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/instances/${rowId}/flow/${startId}/start/`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

//** media verilerini getirir.
export async function GetMediaList(model, rowId) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/instances/${rowId}/media/path`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function PostMedia(data, rowId) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/instances/${rowId}/mediumcontent`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                // "content-type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: data,
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function DeleteMedia(rowId) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/media/${rowId}`,
        {
            method: "DELETE", // POST for create, PUT to update when id already exists.
            headers: {
                // "content-type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetMedia(rowId) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/media/${rowId}/content`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        // .then(handleResponse)
        .then((response) => {
            console.log(response);
            response.blob();
        })

        .catch(handleError);
}

export async function PatchMethod(model, rowId, validate) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/generic/instances/v2/${rowId}?validate=${validate}`,
        {
            method: "PATCH", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json-patch+json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

/**
 * * get user roles
 */

export async function GetUserRoles(pageNumber, pageSize) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/security/roles/v2/?page-number=${pageNumber}&page-size=${pageSize}`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function CreateUser(model) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/security/users/v2`,
        {
            method: "POST", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function UserApi(userId, status, model, roles) {
    return await fetch(
        `https://${
            process.env.REACT_APP_BASE_URL
        }/omnimap/security/users/${userId}${roles ? `/roles` : ""}`,
        {
            method: status, // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: model !== null ? JSON.stringify(model) : null,
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetDataForMap(model) {
  return await fetch(
    `https://${process.env.REACT_APP_BASE_URL}/omnimap/search/?page-size=3000&page-number=1&includes=PROPERTIES,MONITORING,CONTENT,CONTEXT,LOCATIONS`,
    {
      method: "POST", // POST for create, PUT to update when id already exists.
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + getToken(),
        tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
        organisation_identification:
          process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
      },
      body: JSON.stringify(model),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function GetOrganisations(pageNumber, pageSize) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/security/organisations?page-number=${pageNumber}&page-size=${pageSize}`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetActionListByRole(referenceId) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/definitions/configuration/client/adfa2725-a2d2-4df4-8420-b093b3acbad7/code/BULKACTIONS/reference/${referenceId}/`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

/**free format  */
export async function GetFreeFormat(referenceId, methodType, model) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/definitions/configuration/${referenceId}`,
        {
            method: methodType, // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: model !== null ? JSON.stringify(model) : null,
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetFreeFormatById(referenceId) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/definitions/configuration/client/${referenceId}/code/${referenceId}`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetFreeFormatByIdForUserColumnOrder(userId, referenceId) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/definitions/configuration/client/${referenceId}/code/COLUMN_ORDER/reference/${userId}/`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetUserProfile() {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL}/omnimap/security/users/profile`,
        {
            method: "GET", // POST for create, PUT to update when id already exists.
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function BulkImport(model) {
    return new Promise(function (resolve, reject) {
        fetch(
            `https://${process.env.REACT_APP_BASE_URL}/omnimap/import`,
            {
                method: "POST", // POST for create, PUT to update when id already exists.
                headers: {
                    Authorization: "Bearer " + getToken(),
                    tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                    organisation_identification:
                    process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
                },
                body: model,
            }
        )
            .then((res) => {
                handleResponseBulkUpdate(res).then(resolve).catch(reject);
            })
            .catch((err) => reject(handleError(err)));
    });

}

export async function InitiateProcess(model, endpoint) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL_TEST}/${endpoint}`,
        {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            },
            body: JSON.stringify(model),
        }
    )
        .then(handleResponse)
        .catch(handleError);
}

export async function GetActionsOfEndpoint(endpoint) {
    return await fetch(
        `https://${process.env.REACT_APP_BASE_URL_TEST}/${endpoint}/available-actions`,
        {
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: "Bearer " + getToken(),
                tenant_identification: process.env.REACT_APP_TENANT_IDENTIFICATION,
                organisation_identification:
                process.env.REACT_APP_ORGANISATION_IDENTIFICATION,
            }
        }
    )
        .then(handleResponse)
        .catch(handleError);
}